/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from 'react';
import { cn } from '@/shared/ui/utils/tailwind';

export type AnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  underline?: 'always' | 'hover' | 'never';
  className?: string;
};

/**
 * Anchor component with Tailwind styling
 * Replaces Mantine Anchor
 */
export const Anchor = React.forwardRef<HTMLAnchorElement, AnchorProps>(
  ({ underline = 'hover', className, children, ...props }, ref) => {
    const underlineClasses = {
      always: 'underline',
      hover: 'hover:underline',
      never: 'no-underline',
    };

    return (
      <a
        ref={ref}
        className={cn(
          'text-sm text-[var(--link-text)] hover:text-[var(--link-hover-text)]',
          'transition-colors font-semibold underline decoration-[var(--link-text)]/40 underline-offset-2',
          'hover:decoration-[var(--link-hover-text)]',
          underlineClasses[underline],
          className
        )}
        {...props}
      >
        {children}
      </a>
    );
  }
);

Anchor.displayName = 'Anchor';

export default Anchor;
